import { gql, useMutation } from "@apollo/client";

export const UPDATE_FISCAL_YEAR_MUTATION = gql`
  mutation UpdateFiscalYear(
    $fiscalYearId: String!
    $updatedFields: FiscalYearInput!
  ) {
    updateFiscalYear(
      fiscalYearId: $fiscalYearId
      updatedFields: $updatedFields
    ) {
      fiscalYearId
      year
      startDate
    }
  }
`;

export const useUpdateFiscalYear = () => {
  const [updateFiscalYear] = useMutation(UPDATE_FISCAL_YEAR_MUTATION);

  return { updateFiscalYear };
};
